import { render } from "./EnrollModal.vue?vue&type=template&id=54934904"
import script from "./EnrollModal.vue?vue&type=script&lang=js"
export * from "./EnrollModal.vue?vue&type=script&lang=js"

import "./EnrollModal.vue?vue&type=style&index=0&id=54934904&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__